module.exports = __webpack_public_path__ + "img/pdf-class.a7811308.svg";